/* eslint-disable @typescript-eslint/no-misused-promises */
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { useOrganizationApi } from "~/api/GeneratedApi";
import GenericTab from "~/components/GenericTab";
import { setTitle } from "~/redux/reducers/generalReducer";
import LoadingPage from "~/template/components/LoadingPage";
import { useCustomQuery } from "~/utils/hooks/useCustomQuery";
import OrganizationDetailsTab from "./organization/tabs/OrganizationDetailsTab";
import OrganizationRolesTable from "./organization/tabs/OrganizationRolesTable";
import OrganizationUsersTable from "./organization/tabs/OrganizationUsersTable";

type Params = {
  id: string;
  tab: string;
};

const OrganizationPage = (): JSX.Element => {
  const { id, tab } = useParams<Params>();
  const organizationId = parseInt(id, 10);

  const dispatch = useDispatch();
  const { t } = useTranslation("organization-management");
  const organizationApi = useOrganizationApi();

  const {
    isLoading,
    data: organizationData,
    refetch,
  } = useCustomQuery({ key: "organization", id: organizationId }, () =>
    organizationApi.getOrganization(organizationId),
  );

  useEffect(() => {
    if (!organizationData) return;
    dispatch(
      setTitle([
        { label: t("organizations"), to: "/organizations" },
        { label: organizationData.name },
      ]),
    );
  }, [dispatch, organizationData, t]);

  if (isLoading || !organizationData) return <LoadingPage />;

  return (
    <GenericTab
      tab={tab}
      tabs={[
        {
          id: "details",
          label: t("list-details"),
          href: `/organizations/${organizationData?.id}/details`,
          component: (
            <OrganizationDetailsTab
              onOrganizationUpdated={refetch}
              organizationData={organizationData}
            />
          ),
        },
        {
          id: "users",
          label: t("list-users"),
          href: `/organizations/${organizationData?.id}/users`,
          component: (
            <OrganizationUsersTable organizationData={organizationData} />
          ),
        },
        {
          id: "roles",
          label: t("list-roles"),
          href: `/organizations/${organizationData?.id}/users`,
          component: (
            <OrganizationRolesTable organizationData={organizationData} />
          ),
        },
        // {
        //   id: "permissions",
        //   label: t("list-permissions"),
        //   href: `/organizations/${organizationData?.id}/permissions`,
        //   component: (
        //     <OrganizationPermissionsTab organizationData={organizationData} />
        //   ),
        // },
      ]}
    />
  );
};

export default OrganizationPage;
